export const organizationUnitTicketDefaultAssignsMessages = {
  update: (service: string) => `Cập nhật nhân sự dịch vụ ${service}`,
  serviceType: 'Loại dịch vụ',
  user: 'Nhân sự mặc định',
  notConfig: 'Chưa thiết lập'
};
